import {
  completeHsaSessionInput,
  completeHsaSessionOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/complete-hsa-session";
import { unaryRpc } from "@redotech/rpc/definition";

// Finalizes the session: server-side this triggers LMN generation +
// payment routing (stubbed for Phase 7). Returns the redirect URL the
// merchant supplied at session creation so the client can bounce the
// shopper back into Shopify's thank-you flow.
//
// Idempotent: completing an already-complete session returns the same
// value without double-writing.
export const completeHsaSession = unaryRpc({
  name: "completeHsaSession",
  input: completeHsaSessionInput,
  output: completeHsaSessionOutput,
});
